<svg class="visually-hidden">
  <symbol id="i2g-autosave-icon" viewBox="0 0 24 24" stroke="#22A971">
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(2 2)" stroke-width="2.5">
        <circle
          stroke="#dadada"
          cx="9.23076923"
          cy="9.23076923"
          r="9.23076923"
        ></circle>
        <path
          d="M18.4615385,9.23076923 C18.4615385,4.13275616 14.3287823,1.39444012e-13 9.23076923,1.39444012e-13"
          stroke-linecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 9.23076923 9.23076923"
            to="360 9.23076923 9.23076923"
            dur="1s"
            repeatCount="indefinite"
          ></animateTransform>
        </path>
      </g>
    </g>
  </symbol>
</svg>

<div class="title column">
  {{ title }}
</div>
<div *ngIf="autoSave" class="autosave column">
  <div *ngIf="autoSave.savingText" class="saving-state">
    <i2g-icon name="i2g-autosave" size="medium" class="saving-icon"></i2g-icon>
    <span>{{ autoSave.savingText | i2gTranslate }}</span>
  </div>
  <span *ngIf="autoSave.savedText">{{
    autoSave.savedText | i2gTranslate
  }}</span>
</div>
